import { money } from "../lib/util.functions";

class ExtendedWarranty extends HTMLElement {
  #variants
  #warrantyPercentages
  #productPrice
  #productQuantity = 0

  get warrantyPercentages() {
    return this.#warrantyPercentages
  }

  get productPrice() {
    return this.#productPrice
  }

  get productQuantity() {
    return this.#productQuantity
  }

  constructor() {
    super();
    this.span = this.querySelector('span');
  }

  connectedCallback() {
    if (this.dataset.inModal === 'true') {
      this.form = this.parentElement.querySelector('product-form');
      this.#variants.forEach((id, i) => {
        const input = this.form.querySelector(`input[value="${id}"]`);
        const priceInput = this.form.querySelector(`input[name="${input.name}-price"]`);
        priceInput.value = this.#getPrice(this.#warrantyPercentages[i]);
      });
    }
  }

  static get observedAttributes() {
    return ['data-warranty-variants','data-warranty-percentages', 'data-product-price', 'data-product-quantity', 'data-total-price'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-warranty-variants') {
      this.#variants = newValue.split(',')
    }
    //
    if (name === 'data-warranty-percentages') {
      this.#warrantyPercentages = newValue.split(',').map(v => parseFloat(v));
    }
    //
    if (name === 'data-product-price') {
      this.#productPrice = parseInt(newValue);
    }
    //
    if (name === 'data-product-quantity') {
      this.#productQuantity = parseInt(newValue);
    }
    //
    if (this.#productPrice && this.#warrantyPercentages) {
      this.span.textContent = `from ${money(this.#getPrice(this.#warrantyPercentages[0]))}`;
    }
    //
    if (name == 'data-total-price') {
      const totalPrice = parseInt(newValue);
      const options = this.dataset.options.split(',');
      const selected = this.dataset.optionSelected.split('|')[1];
      const curPer = this.#warrantyPercentages[options.indexOf(selected)];
      const correctPrice = this.#getPrice(curPer);
      /* console.log(curPer, totalPrice, correctPrice); */
      if (totalPrice !== correctPrice) {
        const event = new CustomEvent('bundlestep:event', {
          detail: { name: 'update', data: { price: correctPrice, variantId: this.dataset.variantId }, replace: true},
          bubbles: true
        });
        this.dispatchEvent(event);
      }
    }
  }

  #getPrice(precentage) {
    return Math.round((this.#productQuantity ? this.#productQuantity * this.#productPrice : this.#productPrice) * precentage);
  }
}

customElements.define('extended-warranty', ExtendedWarranty);